import type { StickerDesign } from '../utils/Primitives';

export type CreateStickerWhileSlappingProps = {
    theIdentifier: string;
    handleStartPublishing: () => void;
}

export default function CreateStickerWhileSlapping(props: CreateStickerWhileSlappingProps) {

    return(
        <div key={props.theIdentifier} className='mt-6'>
            <div className='flex flex-col items-center cursor-pointer'>
                <div className="text-lg mt-2 mb-2 font-bold text-center">Create A New Sticker:</div>
                <button onClick={(e) => { props.handleStartPublishing()}} className="p-2 border border-gray-400 rounded-md hover:bg-gray-100 transition-transform hover:scale-105">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 3a1 1 0 00-1 1v5H4a1 1 0 100 2h5v5a1 1 0 102 0v-5h5a1 1 0 100-2h-5V4a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
    )
}
